import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css']
})
export class TextEditorComponent implements OnInit {

  @Input() public text;
  @Input() public title;

  // Setup configuration for Quill
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['link'],
          // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'color': [] }],          // dropdown with defaults from theme                                    // remove formatting button
    ]
  };

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  save() {
    this.activeModal.close(this.text);
  }

}
